import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="Terminal demonstration van Avans systemen"
      visualizer="full"
      autoNext={22000}
      terminal={{
        phases: [
          {
            type: 'command',
            content: 'sudo ./breach.sh --target avans.one --parallel osiris.avans.nl',
          },
          {
            type: 'matrix',
            content: 'BYPASSING AVANS SECURITY PROTOCOLS...',
          },
          {
            type: 'access',
            content: 'AVANS ONE & OSIRIS ACCESS ESTABLISHED',
          },
          {
            type: 'command',
            content: 'SELECT * FROM events WHERE name LIKE "%AI Hackathon%"',
          },
          {
            type: 'table',
            content: '',
            header: ['ID', 'NAME', 'ROLE', 'ORGANIZATION'],
            data: [
              ['AV-001', 'Michele F******', 'Program Manager AI', 'Avans AI Accelerator'],
              ['AV-002', 'Ferencz v** W****', 'Communicatieadviseur', 'Avans AI Accelerator'],
              ['AV-003', 'Marte S********', 'Dagvoorzitter', 'AI Hackathon'],
              ['AV-004', 'Babette V*****', 'Senior Management Assistent', 'Avans AI Accelerator'],
            ],
          },
          {
            type: 'command',
            content: './scan_challenges.py --event "AI Hackathon" --type "problem_owners"',
          },
          {
            type: 'table',
            content: '',
            header: ['ORGANIZATION', 'CHALLENGE_TYPE', 'STATUS', 'PARTICIPANTS'],
            data: [
              ['Mijzo', 'Healthcare AI Innovation', 'CONFIRMED', '25 students registered'],
              ['Enexis', 'Energy Grid Optimization', 'CONFIRMED', '18 students registered'],
              ['Rewin', 'Smart Industry Solutions', 'CONFIRMED', '22 students registered'],
            ],
          },
          {
            type: 'command',
            content: './osiris_scan.sh --details --silent',
          },
          {
            type: 'matrix',
            content: 'ANALYZING STUDENT REGISTRATIONS...',
          },
          {
            type: 'warning',
            content: '[!] AVANS IDS DETECTED - INITIATING EVASION PROTOCOL',
          },
          {
            type: 'command',
            content: './cleanup.sh --secure --remove-logs --stealth',
          },
          {
            type: 'access',
            content: 'OPERATION COMPLETED - DIGITAL FOOTPRINT ELIMINATED',
          },
        ],
        config: {
          typingSpeed: 20,
          phaseDelay: 300,
        },
      }}
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
